<template>
  <div style="width:80%;padding:100px">
    <Form
      :model="formData"
      ref="formDataF"
      :rules="ruleValidate"
      :label-width="150"
    >
    <FormItem label="账号" prop="name">
        <Input v-model="formData.name" />
      </FormItem>
      <Row>
        <FormItem label="手机号" prop="mobile" style="width:42%;margin-right:2%">
        <Input
          type="number"
          v-model="formData.mobile"
          maxlength="11"
        />
        </FormItem>
        <FormItem prop="code" style="width:36%;margin:0 20px 0 -150px">
         <Input v-model="formData.code" placeholder="输入验证码" style="width:100%;margin-right:2%"/>
      </FormItem>
      <Button type="primary" @click="getCode"
          >获取验证码</Button
        >
        <span v-show="!show">{{ count }} s</span>
      </Row>
      <FormItem label="新密码" prop="password">
        <Input type="password" v-model="formData.password"/>
      </FormItem>
      <FormItem label="重新输入密码" prop="sec_password">
        <Input type="password" v-model="formData.sec_password"/>
      </FormItem>
      <FormItem style="text-align: right">
        <Button type="info" @click="$router.replace({ name: 'Login'})"
          >返回</Button
        >&nbsp;&nbsp;
        <Button type="primary" @click="save(formData)" :loading="formLoading"
          >确定</Button
        >
      </FormItem>
    </Form>
  </div>
</template>
<script>
import addPage from "../../src/mixins/addPage";
export default {
  data() {
    return {
      formData: {
        name: "",
      },
      show: true,
      count: null,
      ruleValidate: {
        code: [
          { required: true, message: "请填写验证码", trigger: "blur" },
          {
            type: "string",
            pattern: /^\d{4}$/,
            message: "验证码格式有误",
            trigger: "blur",
          },
        ],
        mobile: [
          { required: true, message: "请填写手机号", trigger: "blur" },
          {
            type: "string",
            pattern: /^1[3456789]\d{9}$/,
            message: "手机号格式有误",
            trigger: "blur",
          },
        ],
        sec_password: [
          { required: true, message: "请重新输入密码", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入新密码", trigger: "blur" },
        ]
      },
      formLoading: false,
    };
  },
  mixins: [addPage],
  created() {},
  mounted() {
    this.formData = {};
  },
  methods: {
    save() {
        this.formLoading = true;
        this.$refs.formDataF.validate((valid) => {
            if (valid) {
                this.$axios.post('/app/auth/resetPassword', this.formData).then(res => {
                    this.formLoading = false;
                    if (res.code==1) {
                        this.$Message.success('修改成功');
                        this.$router.replace({ name: "Login" });
                    } else {
                        this.$Message.error(res.msg);
                    }
                });
            } else {
                this.$Message.error('请先完善信息');
                this.formLoading = false;
            }
        })
    },
    getCode() {
      if (this.formData.mobile != "") {
        // 1.首先判断是否未输入手机号码就点击获取验证码
        if (/^1[34578]\d{9}$/.test(this.formData.mobile)) {
          //2.使用正则判断手机输入的验证码是否符合规范
          const TIME_COUNT = 60; // 3.设置时间为60s
          if (!this.timer) {
            this.count = TIME_COUNT;
            this.show = false; // 4.隐藏获取验证码按钮,展示倒计时模块
            this.getPhoneCode(); // 5.调用后端获取验证码接口的函数
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                // 6.设置每秒钟递减
                this.count--;
              } else {
                // 7.递减至0时,显示获取验证码按钮,隐藏倒计时模块,清除定时器this.timer,并将其置为null
                this.show = true;
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          }
        } else {
          this.$Message.error("手机号格式不正确!");
        }
      } else {
        this.$Message.error("请先填写手机号码!");
      }
    },
    getPhoneCode() {
      this.$axios
        .post("/app/auth/sendSms", {
          phone: this.formData.mobile,
          scene: "reset",
        })
        .then((res) => {
          if (res.code == 1) {
            this.$Message.success("发送成功");
          } else {
            this.$Message.error(res.msg);
          }
        });
    },
  },
};
</script>


